export default function SearchHistoryIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.39648 5.34841C3.50731 3.34801 5.63915 1.9906 8.09367 1.9906C11.69 1.9906 14.6031 4.90366 14.6031 8.49999C14.6031 12.0963 11.69 15.0094 8.09367 15.0094C4.49734 15.0094 1.58428 12.0963 1.58428 8.49999H2.58428C2.58428 11.544 5.04962 14.0094 8.09367 14.0094C11.1377 14.0094 13.6031 11.544 13.6031 8.49999C13.6031 5.45594 11.1377 2.9906 8.09367 2.9906C5.95878 2.9906 4.10975 4.20428 3.19275 5.97933H4.90118V6.97933H1.39648V3.47464H2.39648V5.34841ZM8.59367 8.29288V5.4953H7.59367V8.7071L9.99364 11.1071L10.7007 10.4L8.59367 8.29288Z"
        fill="#101010"
      />
    </svg>
  )
}
